/**
 * Ryan O'Dowd
 * 2024-07-28
 * © Copyright 2024 Oakwood Software Consulting, Inc. All Rights Reserved.
 */
import {
  Platform,
} from 'react-native';

const getStyles = ({fonts, globalScale, colors}) => {
  return {
    container: {
      flex: 1,
    },
    referenceWrapper: {
      display: 'flex',
      gap: 8,
      flexDirection: 'row',
      alignItems: 'center',
      marginBottom: 4,
    },
    referenceText: {
      fontFamily: fonts.secondaryBold,
      fontSize: globalScale * 16,
      color: colors.white,
    },
    translationText: {
      fontFamily: fonts.secondaryBold,
      fontSize: globalScale * 12,
      color: colors.white,
    },
    headerText: {
      fontFamily: fonts.secondaryBold,
      fontSize: globalScale * 12,
      color: colors.white,
    },
    verseText: {
      display: Platform.OS === 'web' ? 'inline' : 'flex',
      fontSize: globalScale * 14,
      color: colors.white,
    },
    highlightedText: {
      color: colors.primaryExtraDark,
      backgroundColor: colors.accent,
      paddingHorizontal: globalScale * 2,
      borderRadius: globalScale * 4,
      overflow: 'hidden', // @TODO: what's this for? is this supposed to prevent a space on the right/left side in the middle of a word?
    },
    noLeftPadding: {
      paddingLeft: 0,
    },
    noRightPadding: {
      paddingRight: 0,
    },

    passageDisplayWrapper: {
      maxHeight: 100,
    },
  };
};

export default getStyles;
